import { Header, Menu, Popup } from '@mairistem/composants';
import { formatMontant, Icon } from '@mairistem/finances-utils';
import { ListeTable } from '@mairistem/liste';
import React from 'react';
import type Projet from '../../interfaces/common/projet';
import { renderLabel } from '../../utils/autorisation';
import AutorisationModal from './AutorisationModal';
import './AutorisationListRow.css';

interface AutorisationProgrameListRowProps {
	autorisation: Projet;
	decision: number;
	onFinish: (data: Projet) => void;
}

const AutorisationListRow = ({
	autorisation,
	decision,
	onFinish,
}: AutorisationProgrameListRowProps) => {
	const [isModalOpen, setIsModalOpen] = React.useState(false);
	const [isPopupOpen, setIsPopupOpen] = React.useState(false);

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const handleClosePopup = () => {
		setIsPopupOpen(false);
	};

	const handleFinishModal = (data: Projet) => {
		onFinish(data);
		handleCloseModal();
	};

	const handleOpenModal = () => {
		setIsPopupOpen(false);
		setIsModalOpen(true);
	};

	const handleOpenPopup = () => {
		setIsPopupOpen(true);
	};

	return (
		<>
			<ListeTable.Row key={autorisation.identifiant}>
				<ListeTable.Cell name="libelle">
					<Header size="small">
						<Header.Content>
							{autorisation.libelle}
							<Header.Subheader content={autorisation.code ?? ''} />
						</Header.Content>
					</Header>
				</ListeTable.Cell>
				<ListeTable.Cell name="categorie">
					{autorisation.etiquette?.libelle}
				</ListeTable.Cell>
				<ListeTable.Cell name="montantAutorisation" textAlign="right">
					{formatMontant(autorisation.montantAutorisation)}
				</ListeTable.Cell>
				<ListeTable.Cell name="dateVote">
					{autorisation.dateVote
						? new Intl.DateTimeFormat('fr-FR').format(
								new Date(autorisation.dateVote),
							)
						: 'Non délibérée'}
				</ListeTable.Cell>
				<ListeTable.Cell name="statut">
					{renderLabel(autorisation.statut)}
				</ListeTable.Cell>
				<ListeTable.Cell name="actions">
					<Popup
						content={
							<Menu borderless vertical size="small">
								<Menu.Item
									className="autorisationActionItem"
									onClick={handleOpenModal}
								>
									<Icon iconSet="Lucide" name="Eye" size={16} />
									Consulter / Modifier
								</Menu.Item>
							</Menu>
						}
						on="click"
						onClose={handleClosePopup}
						onOpen={handleOpenPopup}
						open={isPopupOpen}
						size="tiny"
						trigger={
							<Icon
								data-testid={`autorisationActionMenu${autorisation.identifiant}`}
								iconSet="Lucide"
								name="Ellipsis"
							/>
						}
					/>
				</ListeTable.Cell>
			</ListeTable.Row>
			{isModalOpen && (
				<AutorisationModal
					decision={decision}
					identifiantAutorisation={autorisation.identifiant as number}
					onClose={handleCloseModal}
					onFinish={handleFinishModal}
				/>
			)}
		</>
	);
};

export default AutorisationListRow;
